import ExpandablePill from './ExpandablePill';

export default ExpandablePill;
